import {Routes} from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./home/home.component').then(m => m.HomeComponent)
  },
  {
    path: 'images',
    loadComponent: () => import('./images/images.component').then(m => m.ImagesComponent)
  },
  {
    path: 'images/day-detail/:dayNumber',
    loadComponent: () => import('./images/day/day.component').then(m => m.DayComponent)
  },
  {
    path: 'aeltischte',
    loadComponent: () => import('./aeltischte/aeltischte.component').then(m => m.AeltischteComponent)
  },
  {
    path: 'infos',
    loadComponent: () => import('./lagerinfos/lagerinfos.component').then(m => m.LagerinfosComponent)
  }
];
